import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ManageOpenShiftsService } from 'app/modules/manage-shifts/services/manage-open-shifts.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment-timezone';
import { OverlayPanel } from 'primeng';

@Component({
  selector: 'app-manage-shifts-team-week-list',
  templateUrl: './manage-shifts-team-week-list.component.html',
  styleUrls: ['./manage-shifts-team-week-list.component.scss']
})
export class ManageShiftsTeamWeekListComponent implements OnChanges, OnInit {
  @ViewChild('op') op: OverlayPanel;
  @Input() searchTeam: any;
  @Input() fromDate: any;
  @Input() selectedAvailability: any;
  @Input() offset: any;
  @Input() isPastDate: any;
  @Input() providerId: any;
  @Input() serviceRegionIds: any;
  @Output() totalCount: EventEmitter<any> = new EventEmitter<any>();
  @Output() offsetEmmiter: EventEmitter<any> = new EventEmitter<any>();
  hasShowPublishShiftPopUp = false;
  isLoaded = false;
  toDate = new Date();
  limit = 10;
  currentOffset = 10;
  teamDetails: any[] = [];
  dayOffset = AppSettings.ONE_DAY_IN_MILISECOND;
  selectedTeam = '';
  selectedDate: any;
  teamShiftsList: any[] = [];
  sortType = 'asc';
  isOpenShiftPermission = false;


  constructor(private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService, private commonService: CommonBindingDataService ) {
  }

  ngOnInit(): void {
    this.isOpenShiftPermission = this.commonService.hasAccessPresent('GET_OPEN_SHIFT_GRID_LIST');

  }

  ngOnChanges() {
    this.toDate.setTime(moment(this.fromDate).add(6, 'days').valueOf());
    this.getTeamList();
  }

  getTeamList() {
    this.isLoaded = false;
    const formattedFromDate = moment(this.fromDate).format('YYYY/MM/DD');
    const formattedToDate = moment(this.toDate).format('YYYY/MM/DD');
    const formattedStatusId = this.selectedAvailability.length ? this.selectedAvailability : '';
    this.manageOpenShiftsService.getTeamList(formattedFromDate, formattedToDate, this.limit,
       this.offset, this.searchTeam, formattedStatusId, this.sortType, 'week', this.providerId,
       this.serviceRegionIds).subscribe((teamDetails) => {
      this.isLoaded = true;
      this.totalCount.emit(teamDetails.count);
      if (this.offset > this.currentOffset) {
        this.currentOffset = this.offset;
        const data = teamDetails.data;
        this.teamDetails = [...this.teamDetails, ...data];
      } else {
        this.teamDetails = teamDetails.data;
        this.currentOffset = this.offset;
      }
    },
      (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        this.isLoaded = true;
      });
  }

  openShift(teamDetails) {
    this.hasShowPublishShiftPopUp = true;
    this.selectedTeam = teamDetails.teamName;
    this.selectedDate = teamDetails.date;
    const currentDate = new Date();
    const currentFormattedDate  = moment(currentDate).format('MM/DD/YYYY');
    if (currentFormattedDate === this.selectedDate) {
      currentDate.setTime(currentDate.getTime() + (1 * this.dayOffset));
      this.selectedDate = moment(currentDate).format('MM/DD/YYYY');
    } else {
      this.selectedDate = teamDetails.date;
    }
  }

  onClickOfPopupButton(event) {
    if (event !== null) {
      this.uiService.showMessage(event.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    }
    this.hasShowPublishShiftPopUp = false;
    this.getTeamList();
  }

  manageTeamShifts(teamShifts) {
    if (teamShifts.length > 2) {
      return teamShifts.slice(0, 2);
    }
    return teamShifts;
  }

  toggleOverviewPanel(event, teamShifts) {
    this.teamShiftsList = teamShifts;
    this.op.toggle(event);
  }

  sortTeams() {
    this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
    this.offset = 0;
    this.offsetEmmiter.emit(0);
    this.getTeamList();
  }
}
